import { Btn, CustomDropdown, CustomModal, InputText } from '../../../../components'
import React, { useEffect, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { connect } from 'react-redux'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'

const INITIAL_STATE = {
  id: null,
  inventario_id: null,
  inventario: '',
  company: null,
  company_id: null,
  created_at: null,
  selectedCompany: null,
  selectedEstoque: null,
  estoque: null,
  estoque_id: null,
  errorMessage: null,
}

function ModalInventario({
  isVisible,
  onClose,
  onSave,
  onError,
  data,
  selectedTp,
  estoques,
  pInicial,
  pFinal,
}) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (isVisible) {
      setState(prevState => ({
        ...prevState,
        ...data,
        selectedCompany:
          data && data.company_id ? getEmpresas().find(e => e.id === data.company_id) : null,
        selectedEstoque:
          data && data.estoque_id ? estoques.find(e => e.id === data.estoque_id) : null,
      }))
    } else {
      setState({ ...INITIAL_STATE })
    }
  }, [isVisible, data])

  useEffect(() => {
    if (state.errorMessage) {
      onError(state.errorMessage)
    }
  }, [state.errorMessage])

  function onFormContentChange(name, value) {
    setState(prevState => {
      prevState[name] = value
      return { ...prevState }
    })
  }

  function saveInventario() {
    if (!state.selectedCompany) onError('Selecione uma Empresa.')
    else if (!state.selectedEstoque) onError('Selecione um Estoque')
    else if (!state.inventario.length) onError('Insira um nome para o inventario')
    else {
      EstoqueHttp.saveInventario(
        selectedTp,
        {
          id: state.inventario_id ? state.inventario_id : null,
          company_id: state.selectedCompany.id,
          name: state.inventario,
          estoque_id: state.selectedEstoque.id,
        },
        parseToMysqlFormat(pInicial),
        parseToMysqlFormat(pFinal),
      )
        .then(res => onSave(res))
        .catch(err => onError(errorHandler(err)))
    }
  }

  return (
    <CustomModal
      header={`${data && data.id ? 'Editar' : 'Criar'} Inventario`}
      isVisible={isVisible}
      onClose={onClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Nome :"
            marginTop={10}
            value={state ? state.inventario : ''}
            onChange={value => onFormContentChange('inventario', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label="Empresas"
            optionLabel={'name'}
            options={getEmpresas()}
            value={state.selectedCompany}
            onChange={value => onFormContentChange('selectedCompany', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label="Estoque"
            optionLabel={'name'}
            options={estoques}
            value={state.selectedEstoque}
            onChange={value => onFormContentChange('selectedEstoque', value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={saveInventario}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalInventario)
